import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
// ------ Styles ------ //
import styles from './ExhibitorLicenseManager.module.css'
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LicenseItem from '../../../components/LeadCapture/LicenseManager/LicenseItem'

const ExhibitorLicenseManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitor = location.state
    const [loaded, setLoaded] = useState(false)
    const [licenses, setLicenses] = useState([])
    const [licenseCount, setLicenseCount] = useState(0)
    const deactivateLicense = async (e) => {
        let id = e.currentTarget.id;
        let licensesList = await leadCaptureService.deactivateLicense(id);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
    };
    const activateLicense = async (e) => {
        let id = e.currentTarget.id;
        let licensesList = await leadCaptureService.activateLicense(id);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
    };
    const fetchLicenses = async (id) => {
        let licensesList = await leadCaptureService.getExhibitorLicenses(id);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
        setLoaded(true);
    };
    const fetchLicensesCount = async (id) => {
        let licenseCount = await leadCaptureService.getExhibitorLicensesCount(id);
        if (licenseCount) {
            setLicenseCount(licenseCount);
        }
        setLoaded(true);
    };
    useEffect(() => {
        fetchLicensesCount(exhibitor.id);
        fetchLicenses(exhibitor.id);

    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>License Management</h1><br />
            <h2>Mobile App licenses for {exhibitor.firstName} {exhibitor.lastName} - {exhibitor.organization} ({exhibitor.refNumber}).</h2><br />
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <h3>Total Available Licenses: {licenseCount}</h3>
                            <br />
                            {
                                 licenses && licenses.length > 0 ?
                                <>
                                <table className={styles.tableLicenses}>
                                <thead>
                                    <tr className={styles.trLicenses}>
                                        <th className={styles.thLicenses}>
                                            ExhibitorId(RefNumber)
                                            <HoverButton
                                                title={'Exhibitor id'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Exhibitor
                                            <HoverButton
                                                title={'Exhibitor name'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Email
                                            <HoverButton
                                                title={'Email/login string used'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            License Key
                                            <HoverButton
                                                title={'License key'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Active
                                            <HoverButton
                                                title={'Flag for license usage'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Created Date
                                            <HoverButton
                                                title={'Date of first login'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Last Login Date
                                            <HoverButton
                                                title={'Date of last login'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            License Order
                                            <HoverButton
                                                title={'Counter for license usage'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Max Allowed Licenses
                                            <HoverButton
                                                title={'Max allowed licenses count'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>User Actions
                                            <HoverButton
                                                title={'User options'}
                                                messageWidth={75}
                                            /></th>
                                    </tr>
                                </thead>
                                <tbody key={licenses.length}>
                                    {licenses.map((item, index) => (
                                        <LicenseItem
                                            index={index}
                                            license={item}
                                            deactivateLicense={deactivateLicense}
                                            activateLicense={activateLicense}
                                        >
                                        </LicenseItem>
                                    ))}
                                </tbody>

                                        </table></>
                                    : <><div className={styles.errorLicensesMessage }>No licenses used!</div>
                                </>
                                
                            }
                            
                        </>
                }
            </>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default ExhibitorLicenseManager;